module.exports = __webpack_public_path__ + "img/nvr.dddd5cd.png";